import React, { useState, useMemo, useRef } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import { headers } from "../helper";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import countryList from "react-select-country-list";
import useCartContext from "../../hooks/useCartContext";
import { auth, facebook, google, twitter } from "../../firebase";
import { signInWithPopup } from "firebase/auth";
import {
  FacebookLoginButton,
  GoogleLoginButton,
  TwitterLoginButton,
} from "react-social-login-buttons";

const Signuppage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    statusOrResidenceNumber: "",
    dateOfBirth: null,
    email: "",
    password: "",
    // nationality: "",
    phoneNumber: "",
    firstName: "",
    lastName: "",
    confirmPassword: "",
    role: "customer",
  });
  const phoneRef = useRef(null);
  const { updateUserName } = useCartContext();

  const options = useMemo(() => countryList().getData(), []);

  const [initialPhoneNumber, setInitialPhoneNumber] = useState("");

  const [value, setValue] = useState("");

  const [loader, setLoader] = useState(false);

  const changeHandler = (value) => {
    setValue(value);
  };

  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (date) => {
    setFormData((prevState) => ({
      ...prevState,
      dateOfBirth: date,
    }));
  };
  const handlePhoneNumberChange = (country, value, event) => {
    // console.log(value, country, event, "Debugging");

    console.log("value", value);
    console.log("country", country);
    // Check if 'value' and 'country' are valid
    if (value) {
      // Extract the dialCode and name from the 'country' object
      const { dialCode, name } = event;

      // Format the phone number with dialCode
      const formattedPhoneNumber = `+${dialCode}${value}`;
      console.log("dialCode", formattedPhoneNumber);
      // Update the 'phoneNumber' in formData
      setFormData((prevState) => ({
        ...prevState,
        phoneNumber: formattedPhoneNumber,
      }));
    }
  };

  const handleSubmit = () => {
    console.log(formData, "formsdasdf");
    const isFormValid = Object.values(formData).every((value) => !!value);
    console.log(formData, "formData");

    if (!isFormValid) {
      console.log("Please fill in all fields.");
      return;
    }
    if (!termsAndConditions) {
      console.log("Please agreed terms and conditions");
      return;
    }
    setLoader(true);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/signUp`,
        { ...formData },
        {
          headers: headers,
        }
      )
      .then((res) => {
        console.log("res", res);
        setLoader(false);
        toast.success(res.data.message);

        localStorage.setItem("phoneNumber", formData.phoneNumber);
        localStorage.setItem("email", formData.email);
        navigate("/verifysignupotp");
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  const handleSignInWithFirebase = async (provider) => {
    try {
      const result = await signInWithPopup(auth, provider);
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/loginWithGoogle`,
          {
            email: result?.user?.email || "",
            firstName: result?.user?.displayName?.split(" ")[0] || "",
            lastName: result?.user?.displayName?.split(" ")[1] || "",
            loginWithSocial: true,
            role: "customer",
          },
          {
            headers: headers,
          }
        )
        .then((res) => {
          toast.success(res.data.message);
          if (res.status == 200) {
            const name = result?.user?.displayName;
            updateUserName(name);
            localStorage.setItem("accessToken", res.data.accessToken);
            localStorage.setItem("refreshToken", res.data.refreshToken);
            localStorage.setItem("userId", res.data.data._id);
            localStorage.setItem("userName", name);
            localStorage.setItem("email", res.data.data.email);
            navigate("/");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.success("Something went wrong.");
        });
    } catch (err) {
      console.log(err);
      toast.error("Please choose correct Social media");
    }
  };

  const handleSignInWithTwitterFirebase = async (provider) => {
    try {
      const result = await signInWithPopup(auth, provider);
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/loginWithGoogle`,
          {
            email: result?._tokenResponse?.email || "",
            firstName: result?._tokenResponse?.displayName || "",
            lastName: "",
            loginWithSocial: true,
            role: "customer",
          },
          {
            headers: headers,
          }
        )
        .then((res) => {
          toast.success(res.data.message);
          if (res.status == 200) {
            const name = result?._tokenResponse?.displayName;
            updateUserName(name);
            localStorage.setItem("accessToken", res.data.accessToken);
            localStorage.setItem("refreshToken", res.data.refreshToken);
            localStorage.setItem("userId", res.data.data._id);
            localStorage.setItem("userName", name);
            localStorage.setItem("email", res.data.data.email);
            navigate("/");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.success("Something went wrong.");
        });
    } catch (err) {
      console.log(err);
      toast.error("Please choose correct Social media");
    }
  };

  const handle = (nationality) => {
    setFormData((prevState) => ({
      ...prevState,
      nationality: nationality,
    }));
  };

  return (
    <>
      <main>
        <div className="form-section sign-up-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="sign-up-form">
                  <div className="row">
                    <div className=" col-md-6 col-12">
                      <div className="login-form-innerr text-start padding-bottomm">
                        <label className="form-label">
                          Status/residence number
                        </label>
                        <input
                          type="number"
                          name="statusOrResidenceNumber"
                          className="form-control"
                          placeholder="12345678910"
                          onChange={handleChange}
                          value={formData.statusOrResidenceNumber}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="text-start padding-bottomm">
                        <label className="form-label">Date of Birth</label>
                        <div className="position-relative">
                          <DatePicker
                            selected={formData.dateOfBirth}
                            onChange={handleDateChange}
                            dateFormat="dd - MM - yyyy"
                            placeholderText="13 - 09 - 1999"
                            className="form-control"
                          />
                          <img
                            src={"assets/Signup/calender.svg"}
                            alt="calender"
                            className="position-absolute eye"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className=" col-md-6 col-12">
                      <div className="login-form-innerr text-start padding-bottomm">
                        <label className="form-label">First Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Ahmed Khaled"
                          name="firstName"
                          onChange={handleChange}
                          value={formData.firstName}
                        />
                      </div>
                    </div>
                    <div className=" col-md-6 col-12">
                      <div className="login-form-innerr text-start padding-bottomm">
                        <label className="form-label">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Ahmed Khaled"
                          name="lastName"
                          onChange={handleChange}
                          value={formData.lastName}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className=" col-md-6 col-12">
                      <div className="login-form-innerr text-start padding-bottomm">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          onChange={handleChange}
                          value={formData.email}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="text-start contact-form-innerrrr padding-bottomm">
                        <label className="form-label">Phone Number</label>
                        <div className="position-relative">
                          <IntlTelInput
                            containerClassName="intl-tel-input telonSignupPage"
                            inputClassName="form-control"
                            initialValueFormat="national"
                            name="phoneNumber"
                            defaultValue={formData.phoneNumber}
                            ref={phoneRef}
                            defaultCountry="sa"
                            allowDropdown={false}
                            onPhoneNumberBlur={handlePhoneNumberChange}
                            // onPhoneNumberChange={handlePhoneNumberChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className=" col-md-6 col-12">
                      <div className="login-form-innerr text-start padding-bottomm">
                        <label className="form-label">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="****"
                          name="password"
                          onChange={handleChange}
                          value={formData.password}
                        />
                      </div>
                    </div>
                    <div className=" col-md-6 col-12">
                      <div className="text-start padding-bottomm">
                        <label className="form-label">Confirm Password</label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="****"
                          name="confirmPassword"
                          onChange={handleChange}
                          value={formData.confirmPassword}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className=" col-md-6 col-12">
                      <div className="text-start padding-bottomm">
                        <label className="form-label">Nationality</label>
                        <Select
                          className="selectCountry"
                          options={options}
                          value={formData.nationality}
                          onChange={handle}
                          name="nationality"
                        />
                      </div>
                    </div>
                  </div> */}
                  <div className="col-12 linkStyle">
                    <div className="form-check text-start padding-bottomm">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="agreeToTerms"
                        name="agreeToTerms"
                        onChange={(event) =>
                          setTermsAndConditions(event.target.checked)
                        }
                        checked={termsAndConditions}
                      />
                      <label className="form-check-label" for="exampleCheck1">
                        I have read and agreed to the{" "}
                        <Link to={"/termsandcondition"} className="linkStyle">
                          terms and conditions
                        </Link>
                      </label>
                    </div>
                  </div>

                  <button
                    onClick={handleSubmit}
                    className="btn btn-primary mt-5 signupbtn"
                  >
                    {loader == true ? (
                      <div class="spinner-border" role="status">
                        <span class="sr-only"></span>
                      </div>
                    ) : (
                      <span>Continue</span>
                    )}
                  </button>

                  <div className="w-100 d-flex mt-5 justify-content-center">
                    <GoogleLoginButton
                      onClick={() => handleSignInWithFirebase(google)}
                    />
                  </div>

                  <div className="w-100 d-flex justify-content-center">
                    <FacebookLoginButton
                      onClick={() => handleSignInWithFirebase(facebook)}
                    />
                  </div>

                  <div className="w-100 d-flex justify-content-center">
                    <TwitterLoginButton
                      onClick={() => handleSignInWithTwitterFirebase(twitter)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Signuppage;
